import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import '@mdi/font/css/materialdesignicons.min.css'
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/open-sans'
import 'maplibre-gl/dist/maplibre-gl.css'
import './styles/index.css'
import '@web/features/map/utils/registerPmtilesProtocol'
import { FormatRoot } from '@web/components/FormatRoot'
import { initGestionI18n } from './i18n'
import { ensureFreshSession } from './auth/keepSession'
import { App } from './App'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
})

void Promise.all([initGestionI18n(), ensureFreshSession()]).then(() =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <FormatRoot render={() => <App />} />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  ),
)
